// constants/geography.js
export const GEO_OPTIONS = ['Local', 'Regional', 'State', 'National'];
